import { ActionContext } from 'vuex';

export default {
  setLoadingAction(context: ActionContext<LoaderState, RootState>, value: boolean) {
    context.commit('SET_LOADING', value);
  },
};
